var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('photo-preview',{ref:"photoPreview"},[_c('van-col',{staticClass:"share-icon",attrs:{"span":"6"},on:{"click":_vm.hanldeSupport}},[_c('van-icon',{attrs:{"name":"good-job"}}),_c('div',[_vm._v("点赞")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }